import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';

import { theme } from '_constants/theme';
import { hexToRGBA } from '_helpers/theme';

const { colors, devices, fontSizes, spaces } = theme;

const StyledButton = styled.button`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: relative;

  min-height: 56px;
  width: 100%;

  padding-top: ${spaces.smallX}px;
  padding-bottom: ${spaces.smallX}px;
  padding-left: ${spaces.regular}px;
  padding-right: ${spaces.regular}px;

  border-radius: 28px;
  border-width: 1px;
  border-style: solid;
  border-color: ${colors.indigo[600]};
  background-color: ${colors.indigo[600]};

  box-shadow: inset 0 0 2px 2px hsla(0, 0%, 100%, 0.5),
    0 4px 6px -2px rgba(16, 24, 40, 0.03),
    0 12px 16px -4px rgba(16, 24, 40, 0.08);

  font-family: 'Manrope';
  font-size: ${fontSizes.medium}px;
  font-style: normal;
  font-weight: 700;
  line-height: ${`calc(${fontSizes.medium}px * 1.5)`};
  color: ${colors.white};

  ${({ disabled }) =>
    disabled &&
    css`
      border-color: ${colors.gray.background};
      background: ${colors.gray.background};
    `}

  transition: box-shadow 0.3s ease-out;

  &:hover {
    box-shadow: unset;
  }

  @media ${devices.tablet} {
    min-height: 48px;
    font-size: ${theme.fontSizes.medium}px;
    line-height: ${`calc(${theme.fontSizes.medium}px * 1.5)`};
  }
`;

// eslint-disable-next-line react/display-name
const PrimaryButton = forwardRef(
  ({ children, type, disabled, ...restProps }, ref) => {
    return (
      <StyledButton
        ref={ref}
        type={type || 'button'}
        disabled={disabled}
        {...restProps}
      >
        {children}
      </StyledButton>
    );
  }
);

PrimaryButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  type: PropTypes.string,
  disabled: PropTypes.bool,
};

export default PrimaryButton;
